import React from 'react';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import { Grid, GridItem } from 'components/UI/Grid';
import IconItem from './IconItem';
import { useCertificatesInfo } from 'staticQueries/certificates-info';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './Certificates.module.scss';

function Certificates({
  id = 'certificates',
  title,
  description,
  certificateIDs,
  background = 'transparent',
  theme,
  showIconName,
  iconColumnsXsm,
  iconColumnsSm,
  iconColumnsMd,
  iconColumnsLg,
  iconsWrapperMaxWidth,
}) {
  const certificates = useCertificatesInfo(certificateIDs);
  const style = { '--iconsWrapperMaxWidth': iconsWrapperMaxWidth };
  const textColor = background === 'transparent' ? 'white' : 'black';

  return (
    <Container id={id} background={background}>
      <div className={styles.wrapper}>
        <Title tag="p" size="h2" color={textColor}>
          {title}
        </Title>
        <Subtitle size="lg" color={textColor}>
          {description}
        </Subtitle>
        <div className={styles.grid} style={style}>
          <Grid
            xsm={{ cols: iconColumnsXsm }}
            sm={{ cols: iconColumnsSm }}
            md={{ cols: iconColumnsMd }}
            lg={{ cols: iconColumnsLg }}
            xl={{ cols: iconColumnsLg }}
            gutterY="60px"
          >
            {certificates.map((icon, i) => (
              <GridItem key={i} Tag="div">
                {IconItem({ ...icon, showName: showIconName, theme })}
              </GridItem>
            ))}
          </Grid>
        </div>
      </div>
    </Container>
  );
}

Certificates.displayName = 'Certificates';

export default withErrorBoundary(Certificates);
